import { apiClient } from "../axios.config";
import type { Response } from "../dto/response/common.response";
import type {
  SidoResponse,
  SigunguResponse,
} from "../dto/response/region.response";

const model = "/v1/region";

/**
 * Region Service API
 * @module RegionService
 * @description 지역 관련 API
 */
export async function getSidoList(): Promise<Response<SidoResponse[]>> {
  const { data } = await apiClient.get(`${model}/sido`);
  return data;
}

export async function getSigunguList(
  sidoCode: string,
): Promise<Response<SigunguResponse[]>> {
  const { data } = await apiClient.get(`${model}/sigungu`, {
    params: { sidoCode },
  });
  return data;
}
